import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TAuditLogItem } from 'redux/reducers/changeHistory/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { DATE_FILTER } from '../../../ui/EasTable/constants';

export const tableStructure: TTableStructure<keyof TAuditLogItem>[] = [
	{
		name: 'ID',
		selector: 'id' as keyof TAuditLogItem,
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Date time',
		selector: 'dateTime' as keyof TAuditLogItem,
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
		filter: DATE_FILTER,
	},
	{
		name: 'Em ID',
		selector: 'emId' as keyof TAuditLogItem,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Em Name',
		selector: 'emName' as keyof TAuditLogItem,
		show: true,
		sortable: true,
		filterable: false,

		colSpan: 1,
		type: ETableStructureType.EM,
		align: ETableStructureAlign.LEFT,
		value: (item: TAuditLogItem) => {
			return { id: item.emId, name: item.emFullName };
		},
	},

	{
		name: 'Table name',
		selector: 'tableName' as keyof TAuditLogItem,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Table name',
		selector: 'humanReadableTableName' as keyof TAuditLogItem,
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Column name',
		selector: 'humanReadableColumnName' as keyof TAuditLogItem,

		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Column name',
		selector: 'columnName' as keyof TAuditLogItem,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Operation',
		selector: 'operation' as keyof TAuditLogItem,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['INSERT', 'Insert'],
			['UPDATE', 'Update'],
			['DELETE', 'Delete'],
			['CREATE', 'Create'],
			['OTHER', 'Other'],
		],
		colors: [
			['INSERT', 'info.light'],
			['UPDATE', 'warning.light'],
			['DELETE', 'error.light'],
			['CREATE', 'info.light'],
			['OTHER', 'info.light'],
		],
	},
	{
		name: 'Old value',
		selector: 'oldValue' as keyof TAuditLogItem,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'New value',
		selector: 'newValue' as keyof TAuditLogItem,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Author',
		selector: 'author' as keyof TAuditLogItem,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		noName: true,
		selector: 'actions' as keyof TAuditLogItem,
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				name: 'Edit',
				icon: EIconButtons.EDIT,
			},
		],
	},
];
